import { render, staticRenderFns } from "./PainelAdmin.vue?vue&type=template&id=1071cc7c&"
import script from "./PainelAdmin.vue?vue&type=script&lang=js&"
export * from "./PainelAdmin.vue?vue&type=script&lang=js&"
import style0 from "./PainelAdmin.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "PainelAdmin.vue"
export default component.exports